import { type FC } from 'react'

import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'

import './_linkTabs.scss'

interface INavigationTab {
  route: string
  filters:
    | string[]
    | Array<{ label: string; value: string }>
    | Array<string | { label: string; value: string }>
  customClass?: string
  activeFilter: string
  compact?: boolean
}

const LinkTabs: FC<INavigationTab> = ({
  route,
  filters,
  customClass,
  activeFilter,
  compact = false
}) => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()

  const buildUrl = (filter: string) => {
    const newParams = new URLSearchParams(searchParams)

    if (filter === 'all') {
      newParams.delete('type')
    } else {
      newParams.set('type', filter)
    }

    const qs = newParams.toString()
    return qs ? `${route}?${qs}` : route
  }

  const renderLink = (
    filter: string | { label: string; value: string },
    key: number
  ) => {
    const value = typeof filter === 'string' ? filter : filter.value
    const label = typeof filter === 'string' ? filter : filter.label
    const isActive = activeFilter === value

    return (
      <Link
        key={key}
        className={`linktabs__link ${
          isActive
            ? 'linktabs--light__link--active'
            : 'linktabs--light__link--inactive'
        }`}
        to={buildUrl(value)}
      >
        {t(label)}
      </Link>
    )
  }

    return (
    <div
        className={`linktabs linktabs--light ${
        compact ? 'linktabs--compact' : ''
        } ${customClass ? `linktabs__${customClass}` : ''}`}
    >
        {filters.map(renderLink)}
    </div>
    )
}

export default LinkTabs